import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
  const location = useLocation();
  const [domain, setDomain] = useState('');

  useEffect(() => {
    const domain = window.location;

    setDomain(domain);
  }, [location]);

  return (
    <DomainContext.Provider value={domain}>
      {children}
    </DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);